export const siteStats = [
  { value: "1,280+", label: "累计收录短剧" },
  { value: "3,400+", label: "演员与主创资料" },
  { value: "860", label: "花絮与幕后长文" },
  { value: "5 年", label: "持续整理时间" },
];

export const principles = [
  {
    icon: "ri-shield-check-line",
    title: "信息可核实",
    desc: "演员表与主创名单以片尾字幕和官方物料为准，遇到不同版本会并列标注，而不是挑一个看起来最合理的写上去。",
  },
  {
    icon: "ri-draft-line",
    title: "不写空话",
    desc: "每篇花絮都尽量落到具体细节：这场戏拍了几条、道具为什么这么做、灯光参考了什么。空泛的溢美之词会被编辑删掉。",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "评分不掺水",
    desc: "口碑评分只统计真实观剧记录，任何形式的刷分都会被剔除。我们宁可分数看起来不够漂亮，也不做分数生意。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    desc: "短剧更新节奏快，资料页会跟随作品上线情况修订。发现错误可以随时通过下方表单告诉我们。",
  },
];

export const testimonials = [
  {
    name: "追剧的阿雾",
    tag: "都市题材爱好者",
    text: "以前查一部短剧的演员表要翻好几个平台，现在详情页里导演、编剧、演员一次列全，连拍摄花絮都有，省了太多时间。",
  },
  {
    name: "小满不加糖",
    tag: "古装权谋区观众",
    text: "口碑评分帮了大忙。有些剧热度很高但后劲不足，看了这里的评分和评分分布，基本能判断值不值得从头追。",
  },
  {
    name: "场记老周",
    tag: "影视从业者",
    text: "幕后那几篇写得挺实在，布光和道具的细节都是真的，不是编出来的。看得出来编辑是认真问过现场的人。",
  },
];

export const timeline = [
  { year: "2021", text: "从一份个人整理的短剧演员表开始，逐渐积累了第一批资料页。" },
  { year: "2023", text: "开放拍摄花絮专栏，开始跟随剧组做现场记录与人物访谈。" },
  { year: "2025", text: "上线剧集口碑评分体系，所有评分均基于真实观剧记录统计。" },
];